import itemsService from '../../services/items'
import imagesService from '../../services/images'

const state = {
  items: []
}

// getters 
const getters = {
  getItemIndex: (state) => (itemId) => {
    return state.items
                .findIndex(item => item.itemId === itemId);
  },
  getItemById: (state) => (itemId) => {
    return state.items
                .find(item => item.itemId === itemId);
  },
  itemsCountByCategory: (state) => (name) => {
    let count = 0;
    state.items.forEach(i => { 
      if (i.category === name) {
        count++;
      }
    });
    return count;
  },

  itemsCount : (state) => {
    if (state.items != null) {
      return state.items.length;
    }
    else {
      return 0;
    }
  }


}

// actions
const actions = {
  async getItemsAction(context) {
    await itemsService.getItemsByRestaurant()
                      .then( data => { context.commit('setItemsState', data)});
  },
  async getImageAction(context, item) {
    await imagesService.getImageByItem(item.itemId)
                       .then(data => { 
                         context.commit('setImageState', {'item' : item, 'data' : data} ) });
  },
  async getImageUriAction(context, item) {
    await imagesService.getImageUriByItem(item.itemId)
                       .then( data => {
                         context.commit('setImageUriState', {'item' : item, 'data' : data} );
                       });
  },
  async addItemAction(context, payload) {
    let response = await itemsService.createItem(payload.item);
    if(response != null && payload.image != null) {
      let itemId = response.data;
      await imagesService.createImageForItem(itemId, payload.image);
      context.commit('addItemState', payload.item);
    }
    
  },  
  async updateItemAction(context, payload) {
    await itemsService.updateItem(payload.item);
    context.commit('updateItemState', payload.item);
    if (payload.image != null) {
      await imagesService.createImageForItem(payload.item.itemId, payload.image);
    }
    else {
      //delete image
      await imagesService.deleteImageForItem(payload.item.itemId);
    }
  },
  async deleteItemAction(context, item) {
     await itemsService.deleteItem(item.itemId);
     context.commit('deleteItemState', item); 
  }
}

// mutations
const mutations = {
  setItemsState(state, items) {
    state.items = items;
  },
  setImageState(state, payload) {
    let index = state.items
                     .findIndex(i => i.itemId === payload.item.itemId);
    if (index > -1) {
      state.items[index].image = payload.data;
    }
  },
  setImageUriState(state, payload) {
    let index = state.items
                     .findIndex(i => i.itemId === payload.item.itemId);
    if (index > -1) {
      state.items[index].imageUrl = payload.data;
    }
  },
  addItemState(state, item) {
    state.items.push(item);
  },
  updateItemState(state, item) {
    let index = state.items
                     .findIndex(i => i.itemId === item.itemId);
    if (index > -1) {
      state.items[index] = item;
    }
  },
  deleteItemState(state, item) {
    let index = state.items
                     .findIndex(i => i.itemId === item.itemId);
    if (index > -1) {
      state.items.splice(index, 1);
    }                
  }
} 

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}